module.exports = __webpack_public_path__ + "assets/img/luyan.9e871cc0.png";